import React, { useState, useEffect } from "react";
import { Button, Typography, Card }  from "@material-tailwind/react";
import { FormProvider, useForm, UseFormReturn } from 'react-hook-form'
import { useNavigate } from "react-router-dom";
import { Upload } from "iconoir-react";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { Vehicle, MediaType, uploadMediaRequest, updateVehicleRequest, Media, setVehicleRequest } from "../../../../redux/vehicles/actions";
import { Field, RenderFormField } from "../../../../components/DetailsFormField";
import { StyledFixedElement } from "../../../../components/StyledScrollContainer";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../../redux";
import FormCheckbox from "../../../../components/FormCheckbox";
import FileUpload from "../../../../components/FileUpload";
import Loader from "../../../../components/Loader";
import AppImages from "../../../../assets/AppImages";
import { Feature } from "../../../../redux/auth/actions";

export const PLAN_TYPES = [
    { n: "Stay & Showcase", f: "stay_showcase", v: "stay_showcase", type: "string" },
    { n: "Store & Sell", f: "store_sell", v: "store_sell", type: "string" },
]

export const PRICING_TYPES = [
    { n: "Dynamic", f: "dynamic", v: "dynamic", type: "string" },
    { n: "Fixed", f: "fixed", v: "fixed", type: "string" },
]

export interface WarrantyDetails {
    details: string;
    title: string;
    coverage: string;
    info: React.ReactNode;
    years: number;
    upgrade: React.ReactNode;
}

export const WARRANTY_DETAILS: Record<string, WarrantyDetails> = {
    gold_2_24: {
        details: "Gold (2 years or 24K miles)",
        title: "2 years or 24K miles",
        years: 2,
        upgrade: (
            <ul>
                <li>
                    <strong>✅</strong>
                    <span>
                        Included Gold Plan 2yrs / 24,000 mi + Maintenance
                    </span>
                </li>
                <li>
                    <strong>🔒</strong>
                    <span>
                        Upgrade to 4-Year Gold 4yrs/48,000mi + maintenance for $2,000
                    </span>
                </li>
                <li>
                    <strong>🚀</strong>
                    <span>
                        Upgrade to 5-Year Gold 5yrs/60,000mi + maintenance for $2,000
                    </span>
                </li>
                <li>
                    <strong>💎</strong>
                    <span>
                        Upgrade to Lifetime Gold 25yrs / 500,000mi + maintenance for $3,500
                    </span>
                </li>
            </ul>
        ),
        coverage: "Comprehensive protection for 2 years or 24,000 miles, covering major components and providing peace of mind",
        info: (
            <ul className="list-disc pl-5">
                <li>
                    Engine: Covers all internally lubricated parts, including pistons, rings,
                    crankshaft, camshaft, valves, valve springs, timing chain/gears, oil pump, and
                    VVT actuators.
                </li>
                <li>
                    Transmission: Covers internal gears, input and output shafts, torque converter,
                    front pump, planetary assemblies, valve body, and pressure regulators.
                </li>
                <li>
                    Powertrain: Covers drive shaft, ring and pinion gears, carrier assembly, thrust
                    washers, and limited-slip differential.
                </li>
                <li>
                    Electrical: Covers alternator, starter motor, ignition, window motors, seat
                    motors, and door lock actuators.
                </li>
                <li>
                    Cooling System: Covers water pump, radiator, thermostat, heater core, fan motor,
                    and fan clutch.
                </li>
                <li>
                    Fuel System: Covers fuel injectors, fuel pump, fuel tank, and metal fuel lines.
                </li>
                <li>
                    Suspension: Covers control arms, bushings, ball joints, spindles, hub
                    assemblies, sway bars, and stabilizer links.
                </li>
                <li>
                    Brakes: Covers calipers, wheel cylinders, master cylinder, brake booster, ABS
                    pump, and hydraulic control unit.
                </li>
                <li>
                    Air Conditioning: Covers compressor, evaporator, condenser, receiver drier, and
                    AC control module.
                </li>
                <li>
                    Steering: Covers steering gear, rack and pinion, tie rods, power steering pump,
                    and column shaft.
                </li>
                <li>
                    Oil Changes and Maintenance:
                    <ul className="list-disc pl-5">
                        <li>2 oil changes per year — up to $120 per oil change.</li>
                        <li>Tire rotation with air pressure check — up to $30.</li>
                        <li>Brake pad/shoe replacement — up to $150 for front and rear.</li>
                        <li>Front wiper blade replacement — up to $30.</li>
                        <li>Annual alignment — up to $30.</li>
                        <li>New battery — up to $135.</li>
                    </ul>
                </li>
                <li>
                    Repair Coverage:
                    <ul className="list-disc pl-5">
                        <li>
                            Covers repairs at both independent dealers and official dealers (up to
                            $225/hr for labor).
                        </li>
                    </ul>
                </li>
                <li>
                    Extras:
                    <ul className="list-disc pl-5">
                        <li>$500 insurance deductible reimbursement.</li>
                        <li>$2,000 vehicle replacement benefit in the event of a total loss.</li>
                        <li>
                            24/7 roadside assistance with up to $75 for towing and other services.
                        </li>
                        <li>Rental coverage of $35 per day for up to 7 days.</li>
                    </ul>
                </li>
            </ul>
        ),
    },
    gold_4_48: {
        details: "Gold (4 years or 48K miles)",
        title: "4 years or 48K miles",
        years: 4,
        upgrade: (
            <ul>
                <li>
                    <strong>✅</strong>
                    <span>
Included Gold Plan 4yrs / 48,000 mi + Maintenance
                    </span>
                </li>
                <li>
                    <strong>🔒</strong>
                    <span>
Upgrade to 5-Year Gold 5yrs / 60,000mi + maintenance for $2,000
                    </span>
                </li>
                <li>
                    <strong>💎</strong>
                    <span>
Upgrade to Lifetime Gold 25yrs / 500,000mi + maintenance for $3,500
                    </span>
                </li>
            </ul>
        ),
        coverage: "Extended comprehensive protection for 4 years or 48,000 miles, covering key components and systems",
        info: (
            <ul className="list-disc pl-5">
                <li>
                    Engine: Covers all internally lubricated parts, including pistons, rings,
                    crankshaft, camshaft, valves, valve springs, timing chain/gears, oil pump, and
                    VVT actuators.
                </li>
                <li>
                    Transmission: Covers internal gears, input and output shafts, torque converter,
                    front pump, planetary assemblies, valve body, and pressure regulators.
                </li>
                <li>
                    Powertrain: Covers drive shaft, ring and pinion gears, carrier assembly, thrust
                    washers, and limited-slip differential.
                </li>
                <li>
                    Electrical: Covers alternator, starter motor, ignition, window motors, seat
                    motors, and door lock actuators.
                </li>
                <li>
                    Cooling System: Covers water pump, radiator, thermostat, heater core, fan motor,
                    and fan clutch.
                </li>
                <li>
                    Fuel System: Covers fuel injectors, fuel pump, fuel tank, and metal fuel lines.
                </li>
                <li>
                    Suspension: Covers control arms, bushings, ball joints, spindles, hub
                    assemblies, sway bars, and stabilizer links.
                </li>
                <li>
                    Brakes: Covers calipers, wheel cylinders, master cylinder, brake booster, ABS
                    pump, and hydraulic control unit.
                </li>
                <li>
                    Air Conditioning: Covers compressor, evaporator, condenser, receiver drier, and
                    AC control module.
                </li>
                <li>
                    Steering: Covers steering gear, rack and pinion, tie rods, power steering pump,
                    and column shaft.
                </li>
                <li>
                    Oil Changes and Maintenance:
                    <ul className="list-disc pl-5">
                        <li>2 oil changes per year — up to $250 per oil change.</li>
                        <li>Tire rotation with air pressure check — up to $30.</li>
                        <li>Brake pad/shoe replacement — up to $250 for front and rear.</li>
                        <li>Front wiper blade replacement — up to $30.</li>
                        <li>Annual alignment — up to $30.</li>
                        <li>New battery — up to $200.</li>
                    </ul>
                </li>
                <li>
                    Repair Coverage:
                    <ul className="list-disc pl-5">
                        <li>
                            Covers repairs at both independent dealers and official dealers (up to
                            $225/hr for labor).
                        </li>
                    </ul>
                </li>
                <li>
                    Extras:
                    <ul className="list-disc pl-5">
                        <li>$500 insurance deductible reimbursement.</li>
                        <li>$2,000 vehicle replacement benefit in the event of a total loss.</li>
                        <li>
                            24/7 roadside assistance with up to $75 for towing and other services.
                        </li>
                        <li>Rental coverage of $35 per day for up to 7 days.</li>
                    </ul>
                </li>
            </ul>
        ),
    },
    plus_2_24: {
        details: "Plus (2 years or 24K miles)",
        title: "2 years or 24K miles",
        years: 2,
        upgrade: (
            <ul>
                <li>
                    <strong>✅</strong>
                    <span>
Included Plus Plan 4yrs / 48,000 mi + Maintenance
                    </span>
                </li>
                <li>
                    <strong>🔒</strong>
                    <span>
Upgrade to 4-Year Gold 4yrs / 48,000mi + maintenance for $2,000
                    </span>
                </li>
                <li>
                    <strong>🚀</strong>
                    <span>
Upgrade to 5-Year Gold 5yrs / 60,000mi + maintenance for $995
                    </span>
                </li>
                <li>
                    <strong>💎</strong>
                    <span>
Upgrade to Lifetime Gold 25yrs / 500,000mi + maintenance for $3,500
                    </span>
                </li>
            </ul>
        ),
        coverage: "Solid protection for 2 years or 24,000 miles, covering key components and systems",
        info: (
            <ul className="list-disc pl-5">
                <li>
                    Engine: Covers all internally lubricated parts, including pistons, rings,
                    crankshaft, camshaft, valves, valve springs, timing chain/gears, oil pump, and
                    VVT actuators.
                </li>
                <li>
                    Transmission: Covers internal gears, input and output shafts, torque converter,
                    front pump, planetary assemblies, valve body, and pressure regulators.
                </li>
                <li>
                    Powertrain: Covers drive shaft, ring and pinion gears, carrier assembly, thrust
                    washers, and limited-slip differential.
                </li>
                <li>
                    Electrical: Covers alternator, starter motor, ignition, window motors, seat
                    motors, and door lock actuators.
                </li>
                <li>
                    Cooling System: Covers water pump, radiator, thermostat, heater core, fan motor,
                    and fan clutch.
                </li>
                <li>
                    Fuel System: Covers fuel injectors, fuel pump, fuel tank, and metal fuel lines.
                </li>
                <li>
                    Suspension: Covers control arms, bushings, ball joints, spindles, hub
                    assemblies, sway bars, and stabilizer links.
                </li>
                <li>
                    Oil Changes and Maintenance:
                    <ul className="list-disc pl-5">
                        <li>2 oil changes per year — up to $120 per oil change.</li>
                        <li>Tire rotation with air pressure check — up to $30.</li>
                        <li>Front wiper blade replacement — up to $30.</li>
                        <li>Annual alignment — up to $30.</li>
                        <li>New battery — up to $135.</li>
                    </ul>
                </li>
                <li>
                    Repair Coverage:
                    <ul className="list-disc pl-5">
                        <li>
                            Covers repairs at both independent dealers (up to $125/hr for labor) and
                            official dealers (up to $165/hr for labor).
                        </li>
                    </ul>
                </li>
                <li>
                    Extras:
                    <ul className="list-disc pl-5">
                        <li>$500 insurance deductible reimbursement.</li>
                        <li>$2,000 vehicle replacement benefit in the event of a total loss.</li>
                        <li>
                            24/7 roadside assistance with up to $75 for towing and other services.
                        </li>
                        <li>Rental coverage of $35 per day for up to 7 days.</li>
                    </ul>
                </li>
            </ul>
        ),
    },
    plus_4_48: {
        details: "Plus (4 years or 48K miles)",
        title: "4 years or 48K miles",
        years: 4,
        upgrade: (
            <ul>
                <li>
                    <strong>✅</strong>
                    <span>
Included Plus Plan 4yrs / 48,000 mi + Maintenance
                    </span>
                </li>
                <li>
                    <strong>🔒</strong>
                    <span>
Upgrade to 4-Year Gold 4yrs / 48,000mi + maintenance for $2,000
                    </span>
                </li>
                <li>
                    <strong>🚀</strong>
                    <span>
Upgrade to 5-Year Gold 5yrs / 60,000mi + maintenance for $995
                    </span>
                </li>
                <li>
                    <strong>💎</strong>
                    <span>
Upgrade to Lifetime Gold 25yrs / 500,000mi + maintenance for $3,500
                    </span>
                </li>
            </ul>
        ),
        coverage: "Solid protection for 4 years or 48,000 miles, covering essential components and systems",
        info: (
            <ul className="list-disc pl-5">
                <li>
                    Engine: Covers all internally lubricated parts, including pistons, rings,
                    crankshaft, camshaft, valves, valve springs, timing chain/gears, oil pump, and
                    VVT actuators.
                </li>
                <li>
                    Transmission: Covers internal gears, input and output shafts, torque converter,
                    front pump, planetary assemblies, valve body, and pressure regulators.
                </li>
                <li>
                    Powertrain: Covers drive shaft, ring and pinion gears, carrier assembly, thrust
                    washers, and limited-slip differential.
                </li>
                <li>
                    Electrical: Covers alternator, starter motor, ignition, window motors, seat
                    motors, and door lock actuators.
                </li>
                <li>
                    Cooling System: Covers water pump, radiator, thermostat, heater core, fan motor,
                    and fan clutch.
                </li>
                <li>
                    Fuel System: Covers fuel injectors, fuel pump, fuel tank, and metal fuel lines.
                </li>
                <li>
                    Suspension: Covers control arms, bushings, ball joints, spindles, hub
                    assemblies, sway bars, and stabilizer links.
                </li>
                <li>
                    Oil Changes and Maintenance:
                    <ul className="list-disc pl-5">
                        <li>2 oil changes per year — up to $120 per oil change.</li>
                        <li>Tire rotation with air pressure check — up to $30.</li>
                        <li>Front wiper blade replacement — up to $30.</li>
                        <li>Annual alignment — up to $30.</li>
                        <li>New battery — up to $135.</li>
                    </ul>
                </li>
                <li>
                    Repair Coverage:
                    <ul className="list-disc pl-5">
                        <li>
                            Covers repairs at both independent dealers (up to $125/hr for labor) and
                            official dealers (up to $165/hr for labor).
                        </li>
                    </ul>
                </li>
                <li>
                    Extras:
                    <ul className="list-disc pl-5">
                        <li>$500 insurance deductible reimbursement.</li>
                        <li>$2,000 vehicle replacement benefit in the event of a total loss.</li>
                        <li>
                            24/7 roadside assistance with up to $75 for towing and other services.
                        </li>
                        <li>Rental coverage of $35 per day for up to 7 days.</li>
                    </ul>
                </li>
            </ul>
        ),
    },
    none: {
        details: "",
        title: "",
        years: 0,
        coverage: "",
        upgrade: <div></div>,
        info: <div></div>,
    },
};

export const WARRANTY_TYPES = [
    { n: "Gold (2 years or 24K miles)", f: "gold_2_24", v: "gold_2_24", type: "string" },
    { n: "Gold (4 years or 48K miles)", f: "gold_4_48", v: "gold_4_48", type: "string" },
    { n: "Plus (2 years or 24K miles)", f: "plus_2_24", v: "plus_2_24", type: "string" },
    { n: "Plus (4 years or 48K miles)", f: "plus_4_48", v: "plus_4_48", type: "string" },
    { n: "None", f: "none", v: "none", type: "string" },
]

export interface Section {
    title: string;
    subTitle: string;
    type: string;
    fields?: Field[];
    options?: any[];
}

const defaultRequiredValue = true;

export const SECTIONS: Section[] = [
    {
        title: "Add Vehicle",
        subTitle: "Add vehicles fast with specs, photos, and pricing updates.",
        type: "render",
        fields: [
            { n: "VIN", f: "vin", type: "text", editable: true, required: defaultRequiredValue },
            { n: "Make", f: "make_obj", type: "select", options: [], editable: true, required: defaultRequiredValue },
            { n: "Model", f: "model", type: "text", editable: true, required: defaultRequiredValue },
            { n: "Year", f: "year", type: "number", editable: true, required: defaultRequiredValue },
            { n: "Trim", f: "trim", type: "text", editable: true, required: defaultRequiredValue },
            { n: "Miles", f: "miles", type: "number", placeholder: "Enter Miles", editable: true, required: defaultRequiredValue },
            { n: "Engine", f: "engine_type", type: "text", placeholder: "Enter Engine", editable: true, required: defaultRequiredValue },
            { n: "Body Style", f: "body_id", type: "select", options: [], editable: true, required: defaultRequiredValue },
            { n: "Drive Type", f: "drive_type", type: "select", options: [], editable: true },
            { n: "Color Interior", f: "color_interior", type: "text", placeholder: "Enter Color Interior", editable: true },
            { n: "Color Exterior", f: "color", type: "text", placeholder: "Enter Color Exterior", editable: true },
            { n: "Color HEX", f: "color_hex", type: "color", placeholder: "Enter Color HEX", editable: true },
            { n: "Transmission", f: "transmission", type: "select", options: [
                { n: "Automatic", f: "automatic", v: "automatic", type: "string" },
                { n: "Manual", f: "manual", v: "manual", type: "string" },
            ], editable: true },
            { n: "City MPG", f: "city_mpg", type: "number", editable: true },
            { n: "Hwy MPG", f: "hwy_mpg", type: "number", editable: true },
            { n: "Horse Power", f: "horse_power", type: "number", editable: true },
            { n: "Fuel Efficiency", f: "fuel_efficiency", type: "select", options: [
                { n: "High", f: "high", v: "high", type: "string" },
                { n: "Medium", f: "medium", v: "medium", type: "string" },
                { n: "Low", f: "low", v: "low", type: "string" },
                { n: "Very Low", f: "very_low", v: "very_low", type: "string" },
            ], editable: true },
            { n: "Rating Speed", f: "rating_speed", type: "number", min: 0, max: 5, editable: true },
            { n: "Rating Warranties", f: "rating_warranties", type: "number", min: 0, max: 5, editable: true },
            { n: "Rating Experience", f: "rating_experience", type: "number", min: 0, max: 5, editable: true },
            { n: "Rating Customer Service", f: "rating_customer_service", type: "number", min: 0, max: 5, editable: true },
            { n: "Rating Vehicle Quality", f: "rating_vehicle_quality", type: "number", min: 0, max: 5, editable: true },
            { n: "Store Name", f: "store_id", type: "select", options: [], editable: true, hide: "true" },
            { n: "Fuel Type", f: "fuel_type", type: "select", options: [
                { n: "Gasoline", f: "gasoline", v: "gasoline", type: "string" },
                { n: "Diesel", f: "diesel", v: "diesel", type: "string" },
                { n: "Electric", f: "electric", v: "electric", type: "string" },
                { n: "Hybrid", f: "hybrid", v: "hybrid", type: "string" },
            ], editable: true },
            { n: "Number of Doors", f: "number_of_doors", type: "number", editable: true },
            { n: "Vehicle Seating Capacity", f: "vehicle_seating_capacity", type: "number", editable: true },
        ]
    },
    {
        title: "Plan & Pricing",
        subTitle: "Add vehicles fast with specs, photos, and pricing updates.",
        type: "render",
        fields: [
            { n: "Plan Type", f: "plan_type", type: "select", options: PLAN_TYPES, editable: true, required: defaultRequiredValue },
            { n: "Pricing Type", f: "pricing_type", type: "select", options: PRICING_TYPES, editable: true, required: defaultRequiredValue },
            { n: "Sale Price", f: "sale_price", type: "money", editable: true, required: defaultRequiredValue },
            { n: "Reserve Price", f: "reserve_price", type: "money", editable: true, required: defaultRequiredValue },
        ]
    },
    {
        title: "Additional Information",
        subTitle: "Add additional information about the vehicle.",
        type: "render",
        fields: [
            { n: "Title", f: "title_code", type: "select", options: [], editable: true },
            { n: "Number of Owners", f: "owners_number", type: "number", editable: true },
            { n: "Prior Use", f: "prior_use", type: "text", editable: true },
            { n: "About", f: "about", type: "textarea", editable: true },
            { n: "History", f: "history", type: "textarea", editable: true },
            { n: "Has Flood Damage", f: "has_flood_damage", type: "checkbox", editable: true },
            { n: "Has Odometer Problems", f: "has_odometer_problems", type: "checkbox", editable: true },
            { n: "Has Accidents", f: "has_accidents", type: "checkbox", editable: true },
            { n: "Has Dents", f: "has_dents", type: "checkbox", editable: true },
            { n: "Has Been Cleaned", f: "has_been_cleaned", type: "checkbox", editable: true },
            { n: "Has Wheel Issues", f: "has_wheel_issues", type: "checkbox", editable: true },
        ]
    },
    {
        title: 'Warraty',
        subTitle: 'Coverage you can trust. Review details for every vehicle with ease.',
        type: "render",
        fields: [
            { n: "Warranty Type", f: "warranty_type", type: "select", options: WARRANTY_TYPES, editable: true, required: defaultRequiredValue },
            { n: "Details", f: "warranty_details", type: "text", editable: true, readonly: true },
            { n: "Coverage", f: "warranty_coverage", type: "textarea", editable: true, readonly: true },
            { n: "Has Manufacturer Warranty", f: "manufacturer_warranty", type: "checkbox", editable: true },
            { n: "Manufacturer Warranty Expiration", f: "manufacturer_warranty_expiration", type: "date", editable: true, endMonth: new Date(new Date().setFullYear(new Date().getFullYear() + 10)), startMonth: new Date() },
        ]
    },
    {
        title: 'Features',
        subTitle: "Here's a quick overview of its standout features:",
        type: "features",
    },
]

const MEDIA_SECTIONS = [
    {type: "general", name: "General", id: 0, views: [] as MediaType[]},
    {type: "exterior", name: "Exterior", id: 2, views: [] as MediaType[]},
    {type: "interior", name: "Interior", id: 1, views: [] as MediaType[]},
];

export const renderFeatures = (features: Feature[], isEdit: boolean) => {
    return (
        <div className={`mt-6 grid grid-cols-1 md:grid-cols-3 gap-4`}>
            {features?.map((feature, featureIndex) => (
                <div key={featureIndex}>
                    <FormCheckbox
                        name="features"
                        label={feature.name}
                        value={feature.id}
                        readonly={!isEdit}
                        // textClassName="text-[16px] text-[#1654EC] font-[450]"
                    />
                </div>
            ))}
        </div>
    );
}

export const renderShare = (methods: UseFormReturn<any>) => {
    const sale_price = methods.getValues("sale_price");
    const plan_type = methods.getValues("plan_type");

    let our_share = undefined;
    let your_share = undefined;

    let our_percentage = undefined;
    let your_percentage = undefined;


    if (sale_price && ['stay_showcase', 'store_sell'].includes(plan_type)) {
        if (plan_type === 'stay_showcase') {
            our_percentage = 0.045;
            your_percentage = 1 - our_percentage;

            our_share = sale_price * our_percentage;
            if (our_share < 2000) {
                our_share = 2000;
            } else if (our_share > 8000) {
                our_share = 8000;
            }
        } else {
            our_percentage = 0.055;
            your_percentage = 1 - our_percentage;

            our_share = sale_price * our_percentage;
            if (our_share < 2000) {
                our_share = 2000;
            } else if (our_share > 10000) {
                our_share = 10000;
            }
        }

        your_share = sale_price - our_share;

        our_share = our_share.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        your_share = your_share.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    return (
        <div className="w-full md:w-[20%] flex flex-col justify-between gap-y-0">
            <Card className="p-4">
                <Typography className="text-[14px] text-[#64748B] font-bold">
                    Your Share ({your_percentage ? (your_percentage * 100) + '%' : 'N/A'})
                </Typography>
                <Typography className="text-[20px] text-[#1F2937] font-bold">{your_share || 'N/A'}</Typography>
            </Card>
            <Card className="p-4 mb-4">
                <Typography className="text-[14px] text-[#64748B] font-bold">
                    Our Share ({our_percentage ? (our_percentage * 100) + '%' : 'N/A'})
                </Typography>
                <Typography className="text-[20px] text-[#1F2937] font-bold">{our_share || 'N/A'}</Typography>
            </Card>
        </div>
    );
};


function DashboardVehicleNew() {
    const navigate = useNavigate();
    const methods = useForm();
    const dispatch = useDispatch();

    const { auth } = useSelector((state: RootState) => state.auth);
    const [formData, setFormData] = useState<Record<string, any>>({});
    const [sections, setSections] = useState(MEDIA_SECTIONS);
    const { mediatypes, makes_all, vehicle, bodies_all, stores } = useSelector((state: RootState) => state.vehicles);
    const { constants, features } = useSelector((state: RootState) => state.auth);
    const [sectionsMedias, setSectionsMedias] = useState<Record<string, Media[]>>({});

    const onFormSubmit = methods.handleSubmit(data => {
        console.log(data);
        dispatch(updateVehicleRequest({
            vehicle: {
                ...data,
                id: vehicle?.id,
                is_draft: false,
            } as Vehicle,
            update_fields: [
                "id",
                "is_draft",
                 ...Object.keys(data).filter(
                    (key) => !["warranty_coverage", "warranty_details"].includes(key) && data[key] !== null
                )
            ],
            cb: (vehicle: Vehicle) => {
                navigate(`/dashboard/vehicles/inventory/${vehicle.id}`);
            }
        }))
        // onSubmit(data as Vehicle);
    });

    useEffect(() => {
        methods.reset({
            sale_price: null,
            reserve_price: null,
            year: null,
            miles: null,
            city_mpg: null,
            hwy_mpg: null,
            horse_power: null,
            rating_speed: null,
            rating_warranties: null,
            rating_experience: null,
            rating_customer_service: null,
            rating_vehicle_quality: null,
            owners_number: null,
        });
        return
        methods.reset({
            vin: "1HGCM82633A123456",
            make: "Honda",
            model: "Accord",
            year: "2020",
            trim: "EX-L",
            miles: "15000",
            engine_type: "V6",
            color_interior: "Black",
            color: "White",
            sale_price: "25000",
            warranty_details: "Covers all major components and defects",
            warranty_coverage: "12 Months or 15000 Miles",
            features: ["5", "8", "9", "11"],
            body_style: "Sedan",
            drive_type: "Rear-Wheel Drive",
            plan_type: "starter",
            pricing_type: "dynamic",
            warranty_type: "extended",
        });
    }, []);

    useEffect(() => {
        if (auth?.user?.id) {
            if (!vehicle?.is_draft || vehicle?.owner_id !== auth?.user?.id) {
                dispatch(
                    updateVehicleRequest({
                        vehicle: {
                            vin: `draft-${auth?.user?.id}-${new Date().getTime()}`,
                            owner_id: auth?.user?.id,
                            is_draft: true,
                        },
                        update_fields: ["owner_id", "is_draft", "vin"],
                        cb: (vehicle: Vehicle) => {
                            dispatch(setVehicleRequest(vehicle));
                        }
                    })
                );
            }
        }
    }, [auth, vehicle]);

    useEffect(() => {
        console.log('vehicle', vehicle);
        const medias: Record<number, Media[]> = {};
        vehicle?.medias?.forEach((media) => {
            if (!medias[media.section.id]   ) {
                medias[media.section.id] = [];
            }
            medias[media.section.id].push(media);
        });
        setSectionsMedias(medias);
    }, [vehicle]);

    useEffect(() => {
        if (mediatypes.length > 0) {
            MEDIA_SECTIONS.forEach((section) => {
                const mediaType = mediatypes.find((mt) => mt.name === section.name);
                if (mediaType) {
                    section.id = mediaType.id;
                }

                if (section.name === "Interior") {
                    section.views = mediatypes.filter((mt) => mt.is_in);
                } else if (section.name === "Exterior") {
                    section.views = mediatypes.filter((mt) => mt.is_out);
                }
            });
            setSections(MEDIA_SECTIONS);
        }
    }, [mediatypes]);

    useEffect(() => {
        const subscription = methods.watch((value, { name }) => {
            if (!name || !value[name])
                return
            console.log('form', value);
            console.log(`Form field "${name}" changed to`, value[name]);
            if (name === "warranty_type") {
                const warranty = WARRANTY_DETAILS[value[name] as keyof typeof WARRANTY_DETAILS];
                methods.setValue("warranty_details", warranty.details);
                methods.setValue("warranty_coverage", warranty.coverage);
            }
        });
        return () => subscription.unsubscribe();
    }, [methods]);

    useEffect(() => {
        if (constants) {
            SECTIONS.forEach((section) => {
                section.fields?.forEach((field) => {
                    if (field.f !== "vin" && ["SuperUser", "Admin"].includes(auth?.user?.role?.title || "")) {
                        field.required = false;
                        field.hide = "";
                    }
                    if (field.f === "title_code" && field.options?.length === 0) {
                        field.options = constants.TITLE_TYPES.map((type: any) => ({
                            n: type[1],
                            f: field.f,
                            v: type[0],
                            type: "string",
                        }));
                    } else if (field.f === "drive_type" && field.options?.length === 0) {
                        field.options = constants.VEHICLE_DRIVE_TYPES.map((type: any) => ({
                            n: type[1],
                            f: field.f,
                            v: type[0],
                            type: "string",
                        }));
                    }
                });
            });
        }
    }, [constants]);

    useEffect(() => {
        if (bodies_all) {
           SECTIONS.forEach((section) => {
                section.fields?.forEach((field) => {
                    if (field.f === "body_id" && field.options?.length === 0) {
                        // @ts-ignore
                        field.options = bodies_all.map((body) => ({
                            n: body.name,
                            f: field.f,
                            v: body.id,
                            type: "string",
                        }));
                    }
                });
            });
        }
    }, [bodies_all]);

    useEffect(() => {
        if (makes_all) {
           SECTIONS.forEach((section) => {
                section.fields?.forEach((field) => {
                    if (field.f === "make_obj" && field.options?.length === 0) {
                        // @ts-ignore
                        field.options = makes_all.map((make) => ({
                            n: make.name,
                            f: field.f,
                            v: make.id,
                            type: "string",
                        }));
                    }
                });
            });
        }
    }, [makes_all]);

    useEffect(() => {
        if (stores) {
           SECTIONS.forEach((section) => {
                section.fields?.forEach((field) => {
                    if (field.f === "store_id" && field.options?.length === 0) {
                        // @ts-ignore
                        field.options = stores.map((store) => ({
                            n: store.title,
                            f: field.f,
                            v: store.id,
                            type: "string",
                        }));
                    }
                });
            });
        }
    }, [stores]);

    const renderPhotos = () => {
        return (
            <Card className="p-2 md:p-5">
                <Card.Header className="flex justify-between">
                    <div>
                        <Typography className="block font-bold text-primary">
                            Photos
                        </Typography>
                        <Typography type="small" className="block text-foreground">
                            View all the image from the previous year
                        </Typography>
                    </div>
                    <div className="flex items-center gap-x-3">
                        <Button
                            size="sm"
                            variant="outline"
                            color="secondary"
                            onClick={(e: any) =>
                                e.currentTarget.parentElement
                                    ?.querySelector("#general_upload")
                                    ?.click()
                            }
                            className="h-8 flex items-center gap-2 sm:w-auto w-full"
                        >
                            Upload
                            <Upload className="w-5 h-5" />
                        </Button>

                        <input
                            type="file"
                            id={"general_upload"}
                            className="hidden"
                            accept=".jpg,.png,.jpeg"
                            multiple={true}
                            onChange={(e) => {
                                const files = e.target.files;
                                dispatch(
                                    uploadMediaRequest({
                                        vehicle_id: vehicle?.id || 0,
                                        files: files as FileList,
                                        section_id: sections[0].id,
                                    })
                                );
                            }}
                        />
                    </div>
                </Card.Header>
                <Card.Body className="gap-y-5 justify-center items-center min-h-[400px] flex flex-col">
                    {sectionsMedias[sections[0].id] ? (
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-5 justify-stretch">
                            {sectionsMedias[sections[0].id].map((item, index) => (
                                <div
                                    key={index}
                                    className="flex border min-h-[250px] border-gray-200 rounded-md flex-col items-center justify-center gap-y-3"
                                >
                                    <FileUpload
                                        name={`img_${item.id}`}
                                        accept=".jpg,.png,.jpeg"
                                        title={`general_${item.id}`}
                                        gap="gap-y-3"
                                        desc=""
                                        media={item}
                                        onFileChange={(files) => {
                                            if (!vehicle?.id) {
                                                return;
                                            }
                                            dispatch(
                                                updateVehicleRequest({
                                                    vehicle: {
                                                        id: vehicle.id,
                                                        removed_medias: [item.id],
                                                    } as unknown as Vehicle,
                                                    update_fields: ["id", "removed_medias"],
                                                })
                                            );
                                            dispatch(
                                                uploadMediaRequest({
                                                    vehicle_id: vehicle?.id || 0,
                                                    files: files,
                                                    section_id: sections[0].id,
                                                })
                                            );
                                        }}
                                        onFileRemove={(id) => {
                                            withReactContent(Swal)
                                                .fire({
                                                    title: "Are you sure?",
                                                    text: "You won't be able to revert this!",
                                                    icon: "warning",
                                                    showCancelButton: true,
                                                    confirmButtonColor: "#3085d6",
                                                    cancelButtonColor: "#d33",
                                                    confirmButtonText: "Yes, delete it!",
                                                })
                                                .then((result) => {
                                                    if (result.isConfirmed) {
                                                        dispatch(
                                                            updateVehicleRequest({
                                                                vehicle: {
                                                                    id: vehicle?.id || 0,
                                                                    removed_medias: [id],
                                                                } as unknown as Vehicle,
                                                                update_fields: [
                                                                    "id",
                                                                    "removed_medias",
                                                                ],
                                                            })
                                                        );
                                                    }
                                                })
                                                .catch((error: any) => {
                                                    console.log("error", error);
                                                });
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <FileUpload
                            name={`img_general`}
                            isMultiple={true}
                            accept=".jpg,.png,.jpeg"
                            title="General"
                            titleClass="font-bold"
                            btnText="Choose Files"
                            gap="gap-y-5"
                            desc="Upload vehicle images and videos for customers to view."
                            media={null}
                            onFileChange={(files) => {
                                dispatch(
                                    uploadMediaRequest({
                                        vehicle_id: vehicle?.id || 0,
                                        files: files,
                                        section_id: sections[0].id,
                                    })
                                );
                            }}
                        />
                    )}
                </Card.Body>
            </Card>
        );
    }

    const render360Photos = () => {
        return (
            <Card className="p-5 mt-5 gap-y-5 flex flex-col">
                <Card.Header className="flex justify-between">
                    <div className="">
                        <Typography className="block font-bold text-primary">
                            360° view
                        </Typography>
                        <Typography type="small" className="block text-foreground">
                            Upload in the order requested to create a virtual 360º tour.
                        </Typography>
                    </div>
                    <div className="flex items-center gap-x-3">
                        <Button
                            size="sm"
                            variant="outline"
                            color="secondary"
                            className="h-8 flex items-center gap-2 sm:w-auto w-full"
                        >
                            Preview
                            <AppImages.iconEye className="w-5 h-5" />
                        </Button>
                    </div>
                </Card.Header>
                <Card.Body className="py-0 flex flex-col gap-8" key={Math.random()}>
                    {sections
                        .filter((section) => section.views.length > 0)
                        .map((section, index) => (
                            <div
                                key={`${index}-${section.views.length}`}
                                className="flex flex-col gap-5"
                            >
                                <Typography className="block font-bold text-primary">
                                    {section.name}
                                </Typography>
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-5 justify-stretch">
                                    {section.views.map((item, index) => (
                                        <div
                                            key={index}
                                            className="flex border min-h-[250px] border-gray-200 rounded-md flex-col items-center justify-center gap-y-3"
                                        >
                                            <FileUpload
                                                name={`img_${item.id}`}
                                                accept=".jpg,.png,.jpeg"
                                                title={item.name}
                                                gap="gap-y-3"
                                                iconClass={item.icon ? "!w-8 !h-8" : "!w-5 !h-5"}
                                                btnClass="!py-1 !px-2"
                                                Icon={item.icon}
                                                desc=""
                                                media={sectionsMedias[item.id]?.[0] ?? null}
                                                onFileChange={(files) => {
                                                    if (sectionsMedias[item.id]?.[0]) {
                                                        if (!vehicle?.id) {
                                                            return;
                                                        }
                                                        dispatch(
                                                            updateVehicleRequest({
                                                                vehicle: {
                                                                    id: vehicle.id,
                                                                    removed_medias: [
                                                                        sectionsMedias[item.id]?.[0]
                                                                            ?.id,
                                                                    ],
                                                                } as unknown as Vehicle,
                                                                update_fields: [
                                                                    "id",
                                                                    "removed_medias",
                                                                ],
                                                            })
                                                        );
                                                    }
                                                    dispatch(
                                                        uploadMediaRequest({
                                                            vehicle_id: vehicle?.id || 0,
                                                            files: files,
                                                            section_id: item.id,
                                                        })
                                                    );
                                                }}
                                                onFileRemove={(id) => {
                                                    withReactContent(Swal)
                                                        .fire({
                                                            title: "Are you sure?",
                                                            text: "You won't be able to revert this!",
                                                            icon: "warning",
                                                            showCancelButton: true,
                                                            confirmButtonColor: "#3085d6",
                                                            cancelButtonColor: "#d33",
                                                            confirmButtonText: "Yes, delete it!",
                                                        })
                                                        .then((result) => {
                                                            if (result.isConfirmed) {
                                                                dispatch(
                                                                    updateVehicleRequest({
                                                                        vehicle: {
                                                                            id: vehicle?.id || 0,
                                                                            removed_medias: [id],
                                                                        } as unknown as Vehicle,
                                                                        update_fields: [
                                                                            "id",
                                                                            "removed_medias",
                                                                        ],
                                                                    })
                                                                );
                                                            }
                                                        })
                                                        .catch((error: any) => {
                                                            console.log("error", error);
                                                        });
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                </Card.Body>
            </Card>
        );
    }


    return !vehicle ? (
        <Loader />
    ) : (
        <React.Fragment>
            <StyledFixedElement className="z-10 ns-fixed-element bg-transparent isolate w-full -md:w-[calc(100vw-300px-10rem)]">
                <div className="flex gap-3 justify-end p-6">
                    <Button
                        variant="outline"
                        color="secondary"
                        onClick={() => {
                            try {
                                navigate(-1);
                            } catch {
                                navigate("/dashboard/vehicles/inventory");
                            }
                        }}
                        className="mr-1 bg-white"
                    >
                        Cancel
                    </Button>
                    <Button variant="solid" color="info" onClick={onFormSubmit}>
                        Save and Sell
                    </Button>
                </div>
            </StyledFixedElement>
            <FormProvider {...methods}>
                <form
                    className="flex flex-col mt-4"
                    onSubmit={(e) => e.preventDefault()}
                    noValidate
                    autoComplete="off"
                >
                    {SECTIONS.map((section, index) => (
                        <div key={index} className={` ${index === 1 ? "flex justify-between" : ""}`}>
                            <Card className={`p-4 mb-4 ${index === 1 ? "w-full md:w-[79%]" : ""}`}>
                                <Typography className="text-[16px] text-[#1F2937] font-bold">
                                    {section.title}
                                </Typography>
                                <Typography className="mt-2 text-[14px] text-[#64748B] font-[450]">
                                    {section.subTitle}
                                </Typography>

                                {section.type === "render" ? (
                                    <div className={`mt-6 grid grid-cols-1 ${index === 1 ? "md:grid-cols-4" : "md:grid-cols-3"} gap-4`}>
                                        {section.fields?.filter((field) => !field.hide).map((field, fieldIndex) => (
                                            <div key={fieldIndex}>
                                                <RenderFormField
                                                    field={field}
                                                    isEdit={true}
                                                    object={formData}
                                                    setNewObject={setFormData}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                ) : section.type === "features" ? (
                                    renderFeatures(features || [], true)
                                ) : null}
                            </Card>
                            {index === 1 ? (
                                <React.Fragment>
                                    {methods.watch() && renderShare(methods)}
                                </React.Fragment>
                            ) : null}
                        </div>
                    ))}

                    {renderPhotos()}
                    {render360Photos()}
                </form>
            </FormProvider>
        </React.Fragment>
    );
}

export default DashboardVehicleNew;